<template>
  <div>
    <Row>
      <Form ref="queryAttendanceUserForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('ipms.attendance-user.userName.label')" prop="userName">
            <Input v-model="query.userName" :placeholder="$t('ipms.attendance-user.userName.holder')"/>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.userPost.label')" prop="userPost">
        <Select v-model="query.userPost" clearable filterable :placeholder="$t('ipms.attendance-user.userPost.holder')">
          <Option v-for="item in dict.userPost" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
        </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.userCategory.label')" prop="userCategory">
        <Select v-model="query.userCategory" clearable filterable :placeholder="$t('ipms.attendance-user.userCategory.holder')">
          <Option v-for="item in dict.userCategory" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
        </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.attendanceGroup.label')" prop="attendanceGroup">
        <Select v-model="query.attendanceGroup" clearable filterable :placeholder="$t('ipms.attendance-user.attendanceGroup.holder')">
          <Option v-for="item in dict.attendanceGroup" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
        </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.status.label')" prop="status">
        <Select v-model="query.status" clearable filterable :placeholder="$t('ipms.attendance-user.status.holder')">
          <Option v-for="item in dict.status"  :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
        </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-user.remark.label')" prop="remark">
            <Input v-model="query.remark" :placeholder="$t('ipms.attendance-user.remark.holder')"/>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openAttendanceUserDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="attendanceUserTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <!-- <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.attendanceUserTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div> -->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="attendanceUserDrawer" :title="this.$t('drawer.title')[attendanceUserDrawer.type]" :visible.sync="attendanceUserDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <attendanceUser-form ref="attendanceUserForm"/>
        <div class="right-drawer__footer" v-if="attendanceUserDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="attendanceUserDrawer.submiting">{{ attendanceUserDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="attendanceUserDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import dict from '@/components/dict'
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import AttendanceUserForm from '@/views/ipms/attendance-user/components/Form.vue';
Vue.component('attendanceUser-form', AttendanceUserForm);

export default {
  name: 'aip-ipms-attendanceUser-index',
  mixins:[mixin],
  dictParams: ['userPost','userCategory','attendanceGroup','status'],
    components: {
      'dict-tag': dict
    },
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      attendanceUserDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.ipms.AttendanceUser.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openAttendanceUserDrawer(attendanceUser){
      this.attendanceUserDrawer.visible = true
      this.attendanceUserDrawer.type = attendanceUser ? attendanceUser.type : 'add'
      this.$nextTick(()=>{
          if(attendanceUser){
              this.$refs['attendanceUserForm'].getAttendanceUser(attendanceUser.id,attendanceUser.type)
          }else{
            this.$refs['attendanceUserForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.attendanceUserDrawer.submiting = true;
        this.$refs.attendanceUserForm.handleSubmit(
          data=>{
            this.attendanceUserDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.attendanceUserDrawer.visible=false, 1000);
          },
          ()=>{
            this.attendanceUserDrawer.submiting = false;
          }
        )
    },
    deleteAttendanceUser(id){
      api.ipms.AttendanceUser.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.ipms.AttendanceUser.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/

          {key: 'userName', align:'center',minWidth: 100,fixed:'left', title:  this.$t('ipms.attendance-user.userName.label')},
          // {key: 'userPost', align:'left',minWidth: 120, title:  this.$t('ipms.attendance-user.userPost.label')},
          {
            key: 'userPost',
            align: 'center',
            width: 120,

            column:'userPost',
            filters: this.$t('ipms.attendance-user.userPost.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.userPost = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-user.userPost.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.userPost==t.value).label}</div>
            }
          },
          // {key: 'userCategory', align:'left',minWidth: 120, title:  this.$t('ipms.attendance-user.userCategory.label')},
          {
            key: 'userCategory',
            align: 'center',
            width: 120,

            column:'userCategory',
            filters: this.$t('ipms.attendance-user.userCategory.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.userCategory = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-user.userCategory.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.userCategory==t.value).label}</div>
            }
          },
          // {key: 'attendanceGroup', align:'left',minWidth: 120, title:  this.$t('ipms.attendance-user.attendanceGroup.label')},
          {
            key: 'attendanceGroup',
            align: 'center',
            width: 120,

            column:'attendanceGroup',
            filters: this.$t('ipms.attendance-user.attendanceGroup.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.attendanceGroup = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-user.attendanceGroup.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.attendanceGroup==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 120, title:  this.$t('ipms.attendance-user.remark.label')},
          {
            key: 'status',
            align: 'center',
            width: 120,

            column:'status',
            filters: this.$t('ipms.attendance-user.status.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.status = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-user.status.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.status==t.value).label}</div>
            }
          },
          {key: 'createTime', align: 'center', width:200, title: this.$t('ipms.attendance-user.createTime.label'),},
          {key: 'updateTime', align: 'center', width:200, title: this.$t('ipms.attendance-user.updateTime.label'),},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 160,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openAttendanceUserDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openAttendanceUserDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteAttendanceUser(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
